var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "wait-back",
      attrs: { "element-loading-text": "数据加载中" },
    },
    [
      _c("div", { staticClass: "wai-header" }, [
        _c("div", { staticClass: "header-title" }, [
          _c("i", { staticClass: "iconfont-erp icondaihuankuan" }),
          _vm._v(" 待还款("),
          _c("span", [_vm._v(_vm._s(_vm.PendingRepayment))]),
          _vm._v(") "),
        ]),
        _vm._m(0),
      ]),
      _vm.list.length
        ? _c(
            "ul",
            { staticClass: "back-list" },
            [
              _vm._m(1),
              _vm._l(_vm.list, function (item, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "back-item" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            path: "customer/cusDetails",
                            query: { Id: item.CustomerId },
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "offer-name" }, [
                          _vm._v(_vm._s(item.CustomerName)),
                        ]),
                        _c("div", { staticClass: "offer-price" }, [
                          _vm._v(_vm._s((item.Arrears - 0).toFixed(2))),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      !_vm.loading && _vm.list.length == 0
        ? _c(
            "div",
            {
              staticClass: "empty-list",
              staticStyle: { "padding-top": "40px" },
            },
            [
              _c("i", { staticClass: "iconfont-erp iconjingshi" }),
              _vm._v("暂无数据 "),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-icon" }, [
      _c("i", { staticClass: "iconfont-erp icontongbu" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "back-haeder" }, [
      _c("div", { staticClass: "offer-name" }, [_vm._v("欠款客户")]),
      _c("div", { staticClass: "offer-price" }, [_vm._v("金额(元)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }